<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    showLegend: {
      type: Boolean,
      default: true
    },
    // Bas de l'axe vertical. Sans valeur, l'axe part de zéro.
    yMin: {
      type: Number,
      default: null
    }
  },
  watch: {
    chartData () {
      this.render()
    },
    showLegend () {
      this.render()
    },
    yMin () {
      this.render()
    }
  },
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          onClick: () => {},
          labels: {
            boxWidth: 12,
            usePointStyle: true
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              precision: 0,
              fontSize: 10
            },
            gridLines: {
              color: '#E5E7EB'
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: 10,
              autoSkip: true,
              maxTicksLimit: 12
            },
            gridLines: {
              display: false
            }
          }]
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        hover: {
          mode: 'nearest',
          intersect: false
        }
      }
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    render () {
      if (!this.chartData) {
        return
      }

      const [yAxis] = this.options.scales.yAxes
      const hasYMin = Number.isFinite(this.yMin)
      const yTicks = hasYMin
        ? { ...yAxis.ticks, beginAtZero: false, min: this.yMin }
        : yAxis.ticks
      const yAxisOptions = hasYMin
        ? { ...yAxis, ticks: yTicks, afterBuildTicks: (scale, ticks) => this.dropTicksTooCloseToMin(ticks) }
        : yAxis

      this.renderChart(this.chartData, {
        ...this.options,
        legend: {
          ...this.options.legend,
          display: this.showLegend
        },
        scales: {
          ...this.options.scales,
          yAxes: [yAxisOptions]
        }
      })
    },
    // Chart.js ajoute le minimum forcé aux graduations « rondes » : 119 puis 120,
    // 125… Les libellés trop proches du minimum se chevauchent, on les retire.
    dropTicksTooCloseToMin (ticks) {
      const others = ticks.filter(tick => tick !== this.yMin).sort((a, b) => a - b)
      if (others.length < 2) {
        return ticks
      }
      const step = others[1] - others[0]
      return ticks.filter(tick => tick === this.yMin || tick - this.yMin >= step / 2)
    }
  }
}
</script>
